<!--
  This icon is designed especially for Concertgebouw and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol" aria-hidden="true">
    <title>Search</title>
    <path
      fill="currentColor"
      d="M22.8 24c-.3 0-.6-.1-.8-.4L18.4 20c-.8.7-1.8 1.2-2.8 1.6-2.7 1.1-5.9 1.1-8.6 0-1.4-.6-2.6-1.4-3.7-2.4-1.1-1.1-1.9-2.3-2.4-3.7-.6-1.3-.9-2.7-.9-4.2 0-3 1.2-5.8 3.3-8 2.1-2.1 5-3.3 8-3.3s5.8 1.2 8 3.3c2.1 2.1 3.3 5 3.3 8 0 1.5-.3 2.9-.9 4.3-.4 1-1 1.9-1.6 2.8l3.6 3.6c.5.5.5 1.2 0 1.7-.3.2-.6.3-.9.3zM11.3 2.4C8.9 2.4 6.7 3.3 5 5c-1.7 1.7-2.6 3.9-2.6 6.3 0 1.2.2 2.3.7 3.4.4 1.1 1.1 2.1 1.9 2.9.8.8 1.8 1.5 2.9 1.9 2.2.9 4.6.9 6.8 0 1.1-.4 2.1-1.1 2.9-1.9.8-.8 1.5-1.8 1.9-2.9.4-1.1.7-2.2.7-3.4 0-2.4-.9-4.6-2.6-6.3-1.7-1.7-3.9-2.6-6.3-2.6z"
    />
  </svg>
</template>
